import React from 'react';
import TopStrip from '../components/TopStrip';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import HelpButton from '../components/HelpButton';

function PrivacyPolicy() {
  return (
    <>
      <TopStrip />
      <Navbar />

      <section className="py-5 bg-light" data-aos="fade-up" style={{ marginTop:'8.5rem' }}>
        <div className="container">
          <h2 className="text-center mb-5 fw-bold">Privacy Policy</h2>

          <div className="mb-4">
            <h5 className="fw-bold">Personal Information</h5>
            <p>We may collect personal identification information of users in different ways, including, but not limited to, when users visit our site, register on the site, place an order, fill out a form, and in connection with other activities, services, features or resources we make available on our Site.</p>
            <p>Clients are asked for, as appropriate, name, email address, mailing address, phone number etc. These personal identification information are collected only if they voluntarily submit such information to us. You can always refuse to supply personally identification information, except that it may prevent them from engaging in certain service and related activities.</p>
          </div>

          <div className="mb-4">
            <h5 className="fw-bold">Non-Personal Identification Information</h5>
            <p>We may collect non-personal identification information about visitors whenever they interact with our Site. This may include the browser name, type of computer, technical information such as the operating system, Internet service providers, and other similar information.</p>
          </div>

          <div className="mb-4">
            <h5 className="fw-bold">Web Browser Cookies</h5>
            <p>Our Site uses caching and cookies to enhance end user experience. Web browsers place cookies on their hard drive for record-keeping purposes and sometimes to track information. You may choose to set your browser to refuse cookies, or to alert you when cookies are being sent. However, some parts of the application may not function properly if cookies are disabled.</p>
          </div>

          <div className="mb-4">
            <h5 className="fw-bold">Use of Collected Information</h5>
            <ul>
              <li>Information helps us respond to customer service requests and support needs more efficiently.</li>
              <li>We may use email addresses to send order updates, respond to inquiries, and other requests.</li>
              <li>Helps sales and support team contact you for newsletters or promotions you subscribed to.</li>
            </ul>
          </div>

          <div className="mb-4">
            <h5 className="fw-bold">How We Protect Your Information</h5>
            <p>We adopt appropriate data collection, storage, and security practices to protect your personal information, username, password, and transaction details.</p>
            <p>Our payment process complies with PCI vulnerability standards to ensure a secure environment.</p>
            <p>We do not sell, trade, or rent personal identification information. We may share aggregated demographic data with trusted partners (not advertisers) which is not linked to any personal identification.</p>
          </div>

          <div className="mb-4">
            <h5 className="fw-bold">Third-party Links</h5>
            <p>You may find advertising or other content on our Site that links to partner/supplier websites. We are not responsible for the content or privacy practices of these websites.</p>
            <p>These sites may have separate privacy policies. Please review them accordingly.</p>
          </div>

          <div className="mb-4">
            <h5 className="fw-bold">Google Ads</h5>
            <p>Ads is a remarketing and behavioral targeting service provided by Google Inc. It connects this application with the AdWords advertising network and the DoubleClick cookie.</p>
          </div>

          <div className="mb-4">
            <h5 className="fw-bold">Policy Updates</h5>
            <p>DDevOps reserves the right to update this privacy policy at any time. When updated, we will revise the date at the bottom of the page. We encourage users to check this page often to stay informed about how we are protecting your information.</p>
          </div>

          <div className="mb-4">
            <h5 className="fw-bold">Your Acceptance</h5>
            <p>By using this site, you signify your acceptance of this policy. If you do not agree, please do not use our site. Continued use following updates to this policy will be deemed your acceptance of those changes.</p>
          </div>

          <div className="mb-4">
            <h5 className="fw-bold">For Information</h5>
            <p>For any questions related to Terms &amp; Conditions, Service Level Agreements, or Privacy Policy, contact us at <a href="mailto:legal@ddevops.com">legal@ddevops.com</a>.</p>
          </div>

        </div>
      </section>

      <Footer />
      <HelpButton />
    </>
  );
}

export default PrivacyPolicy;
